var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linear / Map & Location / Map Point"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33301 8.45283C3.33301 4.70498 6.31778 1.66675 9.99967 1.66675C13.6816 1.66675 16.6663 4.70498 16.6663 8.45283C16.6663 12.1713 14.5386 16.5104 11.2188 18.0621C10.4449 18.4238 9.55446 18.4238 8.78056 18.0621C5.46078 16.5104 3.33301 12.1713 3.33301 8.45283Z",
    stroke: "#005AA8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Vector_2",
    cx: 10,
    cy: 8.33325,
    r: 2.5,
    stroke: "#005AA8",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPoint);
export default __webpack_public_path__ + "static/media/mapPoint.faa6b96eec760ea6ee088f27cc89ca61.svg";
export { ForwardRef as ReactComponent };